module.exports = __webpack_public_path__ + "media/images/dummy/dummy_thumb-5d2cdc87f98def9c6f1a35d05b93b21e.jpg";